/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Impact, Risk, Opportunity

Values: 0=Impact, 1=Risk, 2=Opportunity
 * @export
 * @enum {number}
 */

export enum DoubleMaterialityIroTypeEnum {
    Impact = 0,
    Risk = 1,
    Opportunity = 2
}


